const mark = {
	elem: {
		// $mark: $('blockquote mark, .hero .hero__title, .home-explore h2, .home-life__heading, .intro p, .wysiwyg .font-intro'),
		$mark: $(''),
	},

	init() {
		if (this.elem.$mark.length > 0) {
			this.elem.$mark.each(function () {
				let text = this.innerHTML;
				text = text.replace(/\S+/g, '<span>$&</span>');
				this.innerHTML = text;
			});
		}
	},
};

export { mark };
